import { render, staticRenderFns } from "./PreferencesFooter.vue?vue&type=template&id=34d130e4&scoped=true&"
import script from "./PreferencesFooter.vue?vue&type=script&lang=ts&"
export * from "./PreferencesFooter.vue?vue&type=script&lang=ts&"
import style0 from "./PreferencesFooter.vue?vue&type=style&index=0&id=34d130e4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34d130e4",
  null
  
)

export default component.exports